import { isProviderErrorLine } from '@agentic-ivy/shared-types';

const BUILDER_STOPPED = /Agent terminated early due to an API error/;
const HIT_A_LIMIT = /hit your .*?(?:limit|budget)|usage limit|rate_limit/i;

/** A failed step's result as a person reads it: the provider's own sentence stays in the record, and never shows. */
export function stepErrorText(result: string): string {
  if (!BUILDER_STOPPED.test(result) && !isProviderErrorLine(result)) return result;
  return HIT_A_LIMIT.test(result) ? 'Stopped: the model hit a usage limit.' : 'Stopped: the model returned an error.';
}

const steps = (n: number) => `${n} step${n === 1 ? '' : 's'}`;

/** A finished run of steps, counting only what worked as completed. */
export function stepsDoneLabel(total: number, failed: number): string {
  if (!failed) return `${steps(total)} completed`;
  return failed === total ? `${steps(failed)} didn't work` : `${steps(total - failed)} completed, ${failed} didn't work`;
}
